import type { Board } from "../board";
import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class MapMarker extends PhysicalThing {
	static key = "MapMarker";
	readonly tag: string;

	constructor(xy: XY, tag: string = "") {
		super(xy, false);
		this.tag = tag;
	}

	isVisible(): boolean {
		return false;
	}

	isTangible(): boolean {
		return false;
	}

	static consume(board: Board, tag?: string): XY[] {
		const markers = board
			.getAllOfType((t): t is MapMarker => t instanceof MapMarker)
			.filter((m) => tag === undefined || m.tag === tag);
		for (const marker of markers) {
			board.removeThing(marker);
		}
		return markers.map((m) => m.xy);
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), tag: this.tag };
	}

	static deserialize(data: any): MapMarker {
		const m = new MapMarker(deserializeXY(data.xy), data.tag ?? "");
		m.visualId = data.visualId;
		return m;
	}

	static override initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const tag = typeof props?.tag === "string" ? props.tag : "";
		const marker = new MapMarker(xy, tag);
		board.putThing(marker);
		return [marker];
	}
}
